import React, { Component } from 'react';
import ScreenContainer from '../ui/ScreenContainer';
import SimpleEditGrid from '../ui/EditGrid/SimpleEditGrid.js';
import Button from '@mui/material/Button';
import UiButton from '../ui/Button';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import "../../index.css";
import styles from '../../style.js';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import EndProcessAction from './EndProcessAction';
import {getProcessGroups} from '../ProcessGroup/apiRequestService';
import {getProcessType} from '../ProcessType/apiRequestService';
import {getParametersByGroupCodes} from '../Parameter/apiRequestService';
import {createApproval} from './apiRequestService';
import { history } from '../../App';
import BasicPageComponent from '../BasicPageComponent';
import {getUsers} from '../NewProcess/apiRequestService';
import * as Actions from '../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PropTypes from 'prop-types';

class NewProcess extends Component {
 

  constructor(props) {
    super(props);
    this.guidEmpty = '00000000-0000-0000-0000-000000000000';

    this.state = {
      isDisabled:false,
      templateName:'',
      templateDescription:'',
      processGroup:this.guidEmpty,
      processType:this.guidEmpty,
      processGroupsList : [],      
      processTypesList : [],
      processFile:{},
      fileUploadIconHidden:true,
      processTypeFileName:'',
      fileBytes:'',
      fileReadValidationCheck:false,
      signOrder:1,
      sufficientSigner:'0',
      sufficientSignerList : [],
      internalSigners:[],
      internalSignersColumns : [
        { field: 'id', hide: true },
        { field: 'userInfo',headerName:'Kullanıcı',type:'singleSelect',labelText:'Kullanıcı', width: 428,
          renderCell: (params) => (<div>{params.value.fullName}</div>),
        dataList:[],keyField:'id',valueField:'fullName'},
        { field: 'signType',headerName:'Onay Türü',type:'singleSelect',labelText:'Onay Türü', width: 428,
          renderCell: (params) => (<div>{params.value.parameterName}</div>),
        dataList:[],keyField:'parameterValue',valueField:'parameterName'},
        { field: 'recordStatus', hide: true }
      ],
      internalSignersColumnsVisiblity:{id:false,recordStatus:false},
      notificationType:0,
      notificationTypesList:[],
      endProcessNotificationType:0,
      endProcessNotificationTypeList:[],
      endOperationAction:{actionId:0,registeredFtp:null,registeredEmail:null,newEmail:''},
      endProcessActionsList:[],
      isEndProcessLoaded:false,
      parameterGroups:['SUFFICIENT_NUMBER_OF_SIGNERS','SIGN_TYPE','NOTIFICATION_TYPE','END_PROCESS_NOTIFICATION','COMPLETED_PROCESS'],
      additionalFileUploadIconHidden: true,
      additionalProcessFile: {},    
      additionalFileBytes:'',
      additionalDocRequirement: ''
    };
  }


  componentDidMount() {
    const {parameterGroups}=this.state;

    //Süreç Grubu
    getProcessGroups()
    .then((response) => {
      this.setState({processGroupsList : response.data});
    })
    .catch((exception) => {
      this.props.actions.setNotification("Süreç grubu bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getProcessGroups exception: ' + JSON.stringify(exception));
    });

    //İmzacılar
    getUsers()
    .then((response) => {
      this.state.internalSignersColumns.filter(item => item.field=="userInfo").map((item) =>
        item.dataList=response.data);
    })
    .catch((exception) => {
      this.props.actions.setNotification("İmzacı bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getUsers exception: ' + JSON.stringify(exception));
    });   

    //Parametre bilgileri
    getParametersByGroupCodes(parameterGroups)
    .then((response) => {
      const datas=response.data;
      for (const element of datas) {
        const parameter = element;
        switch (parameter.groupCode) {
          case 'SUFFICIENT_NUMBER_OF_SIGNERS':
            this.setState({sufficientSignerList : parameter.parameters});
            break;
          case 'SIGN_TYPE':
            this.state.internalSignersColumns.filter(item => item.field=="signType").map((item) =>item.dataList=parameter.parameters);
            break;
          case 'NOTIFICATION_TYPE':
            this.setState({notificationTypesList : parameter.parameters});
            break;
          case 'END_PROCESS_NOTIFICATION':
            this.setState({endProcessNotificationTypeList : parameter.parameters});
            break;
          case 'COMPLETED_PROCESS':
            this.setState({endProcessActionsList : parameter.parameters,isEndProcessLoaded:true});
            break;
          default:
            break;
        }
      }
    })
    .catch((exception) => {
      this.props.actions.setNotification("Parametre bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getParametersByGroupCodes exception: ' + JSON.stringify(exception));
    }); 
  }

  handleChange = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    this.setState({ [fieldName]: fieldValue });
  };

  processGroupChange = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    this.setState({ [fieldName]: fieldValue });

    //Süreç Türü    
    getProcessType(fieldValue)
    .then((response) => {
      this.setState({processTypesList : response.data,processType:this.guidEmpty});
    })
    .catch((exception) => {
      this.props.actions.setNotification("Süreç türü bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getProcessTypes exception: ' + JSON.stringify(exception));
    }); 
  };
  
  processTypeChange = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;
    const{processTypesList}=this.state;

    for (let i = 0; i < processTypesList.length; i++) {
      if(processTypesList[i].id==fieldValue){
        this.setState({ processTypeFileName:processTypesList[i].fileUrl, additionalDocRequirement: processTypesList[i].additionalDocumentRequirement});
        break;
      }
    }

    this.setState({ [fieldName]: fieldValue });  
  };

  fileChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];

    reader.readAsArrayBuffer(file);
    reader.onloadend = () => {
      console.log('image read complete');
      const fileBytes = new Uint8Array(reader.result);

      const imageEncoded = btoa(fileBytes.reduce(function (data, byte) {
        return data + String.fromCharCode(byte);
    }, ''));

      this.setState({fileUploadIconHidden:false,fileBytes:fileBytes,
        processFile:{fileName:file.name,fileType:file.type,size:file.size,fileData:imageEncoded}});
    };
  }

  additionalFileChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];

    reader.readAsArrayBuffer(file);
    reader.onloadend = () => {
      console.log('image read complete');
      const additionalFileBytes = new Uint8Array(reader.result);

      const imageEncoded = btoa(additionalFileBytes.reduce(function (data, byte) {
        return data + String.fromCharCode(byte);
    }, ''));

      this.setState({additionalFileUploadIconHidden:false,additionalFileBytes:additionalFileBytes,
        additionalProcessFile:{fileName:file.name,fileType:file.type,size:file.size,fileData:imageEncoded}});
    };
  }

  fileClick = (e) => {
    e.target.value = null;
    this.setState({fileUploadIconHidden:true,processFile:{}});
  }

  additionalFileClick = (e) => {
    e.target.value = null;
    this.setState({additionalFileUploadIconHidden:true,additionalProcessFile:{}});
  }

  fileOpen = (e) => {
    const{processFile,fileBytes}=this.state;
    
    let blob = new Blob([fileBytes], { type: processFile.fileType });
    let url = URL.createObjectURL(blob);
    window.open(url);
  }

  additionalFileOpen = (e) => {
    const{additionalProcessFile,additionalFileBytes}=this.state;
    
    let blob = new Blob([additionalFileBytes], { type: additionalProcessFile.fileType });
    let url = URL.createObjectURL(blob);
    window.open(url);
  }

  fileOpenForProcessType = (e) => {
    const{processTypeFileName}=this.state;
    window.open(processTypeFileName);
  }

  handleCheckBoxChange = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.checked;

    this.setState({ [fieldName]: fieldValue });
  };

  handleRadioSignOrder = event => {
    this.setState({ signOrder: event.target.value });
  };

  handleOnGridChange(data,id) {
    this.setState({ [id]: data });
  }

  handleValidation(rows,newRow) {
    const isPresent = rows.some(item => item.userInfo.id === newRow.userInfo.id);
    const isInitialsPresent = rows.some(item => item.signType.parameterValue === '3' && item.signType.parameterValue === newRow.signType.parameterValue);

    if(isPresent){
      this.props.actions.setNotification('Aynı kullanıcıyı birden fazla kez tanımlayamazsınız.', 'error');
      return true;
    }
    if(isInitialsPresent){
      this.props.actions.setNotification('Birden fazla paraf imzacı tanımlayamazsınız.', 'error');
      return true;
    }
    return false;
  }

  handleEndProcessActionChange(item) {
    this.setState({ endOperationAction: item });
  }

  handleSave = () => {
    const { templateName, templateDescription, processFile, processGroup, processType, fileReadValidationCheck,
      signOrder, sufficientSigner, internalSigners, notificationType, endProcessNotificationType,endOperationAction, 
      additionalProcessFile, additionalDocRequirement} = this.state;

    //Ek doküman gerekiyorsa ama yüklenmemişse kullanıcıyı uyar
    if (additionalDocRequirement === 'Necessary' && (!additionalProcessFile || _.isEmpty(additionalProcessFile.fileData))) {
      this.props.actions.setNotification('Bu süreç türü için ek doküman yüklenmesi zorunludur.', 'warning');
      return;
    }
    this.setState({isDisabled:true});

    setTimeout(() => {
      console.log("New Process Template Button Disable");
      this.setState({isDisabled:false});
    },3000);

    const newApproval={
      name:templateName,
      description:templateDescription,
      fileInfo:processFile,
      processGroup:processGroup,
      processType:processType,
      isReadBeforeSign:fileReadValidationCheck,
      signOrder:signOrder,
      sufficientSigner:sufficientSigner,
      internalSigners:internalSigners,
      externalSigners:[],
      notificationType:notificationType,
      endProcessNotificationType:endProcessNotificationType,
      endOperationAction:endOperationAction,
      additionalFileInfo: additionalProcessFile
    }

    createApproval(newApproval)
    .then((responseJson) => {
      history.push('/processmanagement');
      console.log(responseJson);
    }).catch((error) => {
        if (!_.isNil(error.Message)) {
          this.props.actions.setNotification(error.Message, 'error');
        } else {
          this.props.actions.setNotification('Süreç başlatılamadı.Girmiş olduğunuz değerlerde sorun olabilir.', 'error');
        }
    })
    .finally(()=>{
      this.setState({loading: false});
    });
  };


  render() {
    const {templateName,templateDescription,processGroup,processType,processGroupsList,processTypesList,fileUploadIconHidden,fileReadValidationCheck,signOrder
      ,sufficientSigner,sufficientSignerList,internalSigners,internalSignersColumns,internalSignersColumnsVisiblity,notificationType,notificationTypesList
      ,endProcessNotificationType,endProcessNotificationTypeList,processFile,endProcessActionsList,isEndProcessLoaded,processTypeFileName,isDisabled,additionalProcessFile,
    additionalFileUploadIconHidden, additionalDocRequirement} = this.state;
    return (
      <div>
      <BasicPageComponent>
      <ScreenContainer>
      <Box sx={{ width: '100%' }}>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

        <Grid item xs={12}>
          <Box className="row" sx={styles.boxClass}>        
            <div className="headerStyle col-sm-12"><h4>Süreç İşlem Tanımı</h4></div>
            <div className="component col-12 col-sm-4" >
              <InputLabel id="template-label" style={styles.label}>Süreç Adı</InputLabel>
              <TextField className='customInputText' sx={styles.textField} labelId="template-label" id="templateNameText" name="templateName" value={templateName}
                variant="outlined" onChange={this.handleChange} placeholder="Süreç Adı" inputProps={{ maxLength: 50 }}/>
            </div>

            <div className="component col-12 col-sm-4" >
              <InputLabel id="templateDescription-label" style={styles.label}>Süreç Açıklaması</InputLabel>
              <TextField className='customInputTextarea' style={{width: '100%'}} InputProps={styles.multiline} multiline rows={4} labelId="templateDescription-label" 
                id="templateDescriptionText" name="templateDescription" value={templateDescription} variant="outlined" onChange={this.handleChange} placeholder="Süreç Açıklaması" inputProps={{ maxLength: 250 }}/>
            </div>
            
            <div className="headerStyle col-sm-12" >
              {/* <InputLabel id="templateDescription-label" style={styles.label}>Süreç Dosyası</InputLabel> */}
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <input className="inputStyle" id="contained-button-file" type="file" onClick = {this.fileClick} onChange = {this.fileChange}/>
                <label htmlFor="contained-button-file">
                  <UiButton className='customFileUploadBtn' text = "Dosya Yükle" component = "span"/>
                </label>
              </div>
              <div style={{paddingLeft:'inherit'}}>
                {/* <img src={require('../../images/success_old.png')} alt="Succes Logo" width={40} height={40} hidden={fileUploadIconHidden}/> */}
                <CheckCircleOutlineIcon sx={{color: "#239D60",fontSize: 50}} hidden={fileUploadIconHidden}/>
              </div>
              <div className="component col-12 col-sm-4" >
                <Box component="span" sx={{ p: 2, border: '1px dashed grey' }} hidden={fileUploadIconHidden}>
                  <Button onClick = {this.fileOpen}>{processFile.fileName}</Button>
                </Box>
              </div>   
            </div>          
          </Box>
        </Grid>


        <Grid item xs={12}>
          <Box sx={styles.boxClass}>        
            <div className="headerStyle"><h4>Süreç Ayrıntıları</h4></div>
            <div className='component row'>
              <div className='sameLine col-12 col-sm-4'>
                <InputLabel id="processGroupLabel" style={styles.label}>Süreç Grubu</InputLabel>
                <Select
                  className='customSelect'
                  fullWidth
                  labelId="processGroupLabel"
                  id="processGroupSelect"
                  value={processGroup}
                  name="processGroup"
                  style={styles.selectField}
                  onChange={this.processGroupChange}>
                  {processGroupsList.map((pGroup) => (
                    <MenuItem key={pGroup.id} value={pGroup.id}>
                      <div style={styles.selectField}>{pGroup.name}</div>
                    </MenuItem>
                  ))}
                </Select>                
              </div>
              <div className='sameLine col-12 col-sm-4'>
                <InputLabel id="processTypeLabel" style={styles.label}>Süreç Türü</InputLabel>
                <Select
                  className='customSelect'
                  fullWidth
                  labelId="processTypeLabel"
                  id="processTypeSelect"
                  value={processType}
                  name="processType"
                  style={styles.selectField}
                  onChange={this.processTypeChange}>
                  {processTypesList.map((pType) => (
                    <MenuItem key={pType.id} value={pType.id}>
                      <div style={styles.selectField}>{pType.processTypeName}</div>
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div  className='sameLine col-12 col-sm-4' style={{margin:'auto'}}>
                <Box component="span" sx={{ p: 2, border: '1px dashed grey' }} hidden={_.isEmpty(processTypeFileName)}>
                  <Button onClick = {this.fileOpenForProcessType}>Şablon İndir</Button>
                </Box>
              </div>
            </div> 
            <div className="headerStyle col-sm-12" >
              {/* <InputLabel id="templateDescription-label" style={styles.label}>Süreç Dosyası</InputLabel> */}
              <div style={{display: 'flex', flexDirection: 'column'}} hidden={_.isEmpty(additionalDocRequirement)}>
                <input className="inputStyle" id="contained-button-additional-file" type="file" onClick = {this.additionalFileClick} onChange = {this.additionalFileChange}/>
                <label htmlFor="contained-button-additional-file">
                  <UiButton className='customAdditionalFileUploadBtn' text = "Ek Dosya Yükle" component = "span"/>
                </label>
              </div>
              <div style={{paddingLeft:'inherit'}}>
                {/* <img src={require('../../images/success_old.png')} alt="Succes Logo" width={40} height={40} hidden={fileUploadIconHidden}/> */}
                <CheckCircleOutlineIcon sx={{color: "#239D60",fontSize: 50}} hidden={additionalFileUploadIconHidden}/>
              </div>
              <div className="component col-12 col-sm-4" >
                <Box component="span" sx={{ p: 2, border: '1px dashed grey' }} hidden={additionalFileUploadIconHidden}>
                  <Button onClick = {this.additionalFileOpen}>{additionalProcessFile.fileName}</Button>
                </Box>
              </div>   
            </div>

            {/* <div className="component">
              <FormControlLabel className='CustomSignatureCheckbox' control={<Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 20 } }} checked={fileReadValidationCheck} 
              onChange={this.handleCheckBoxChange} name="fileReadValidationCheck" />} label="Dosya imzalanmadan önce görüntülensin (Sadece PDF)" />
            </div> */}

            
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box sx={styles.boxClass}>
            <div className="headerStyle "><h4>Süreç İmzalama Sırası</h4></div>
            <div className='component row'>
            <div className='sameLine col-12 col-sm-4'>
            <InputLabel style={styles.label}>Süreç İmzacı Sayısı</InputLabel>
                {/* <FormControlLabel control={ */}
                <Select
                  className='customSelect'
                  fullWidth
                  id="sufficientSignerSelect"
                  value={sufficientSigner}
                  name="sufficientSigner"
                  style={styles.selectField}
                  onChange={this.handleChange}
                >
                  {sufficientSignerList.map((item) => (
                    <MenuItem key={item.parameterValue} value={item.parameterValue}>
                      <div style={styles.selectField}>{item.parameterName}</div>
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div className='sameLine col-12 col-sm-4'>
                <RadioGroup
                  name="signOrderRadioGrpoup"
                  value={signOrder}
                  onChange={this.handleRadioSignOrder}>
                  <FormControlLabel value="1" control={<Radio />} label={<div style={styles.formLabel}>Listedeki Kullanıcılar Girilen Sırayla İmzalasın</div>}/>
                  <FormControlLabel value="2" control={<Radio />} label={<div style={styles.formLabel}>Listedeki Kullanıcılar Sıra Olmadan İmzalayabilsin</div>} />
                </RadioGroup>
              </div>
              
            </div>
          </Box>
        </Grid>

        <Grid item xs={12} >
          <Box sx={styles.boxClass} >
            <div className="headerStyle"><h4>Onaycı Ekle</h4></div>
            <div className='component'>
              <SimpleEditGrid rows={internalSigners} columns={internalSignersColumns} columnVisibilityModel={internalSignersColumnsVisiblity} rowsReOrder
              gridHeight={400} dialogTitle="Onaycı Ekle" onGridChange = {(e) => this.handleOnGridChange(e,"internalSigners")} validation={(a,b)=>this.handleValidation(a,b)}/>
            </div>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box sx={styles.boxClass}>
            <div className="headerStyle" style={{ marginTop: '83px'}}><h4>Bilgilendirme</h4></div>
            <div className='component row'>
              <div className='sameLine col-12 col-sm-4'>
              <InputLabel id="notificationTypeLabel" style={styles.label}>Bilgilendirme Türü</InputLabel>
              <Select
                className='customSelect'
                fullWidth
                labelId="notificationTypeLabel"
                id="notificationTypeSelect"
                value={notificationType}
                name="notificationType"
                style={styles.selectField}
                onChange={this.handleChange}>
                {notificationTypesList.map((nType) => (
                  <MenuItem key={nType.parameterValue} value={nType.parameterValue}>
                    <div style={styles.selectField}>{nType.parameterName}</div>
                  </MenuItem>
                ))}
              </Select>
              </div>
              <div className='sameLine col-12 col-sm-4'>
              <InputLabel id="endNotificationTypeLabel" style={styles.label}>Süreç Sonu Bilgilendirme</InputLabel>
              <Select
                className='customSelect'
                fullWidth
                labelId="endNotificationTypeLabel"
                id="endNotificationTypeSelect"
                value={endProcessNotificationType}
                name="endProcessNotificationType"
                style={styles.selectField}
                onChange={this.handleChange}>
                {endProcessNotificationTypeList.map((nType) => (
                  <MenuItem value={nType.parameterValue}>
                    <div style={styles.selectField}>{nType.parameterName}</div>
                  </MenuItem>
                ))}
              </Select>
              </div>
            </div>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <div>
            {isEndProcessLoaded&&<EndProcessAction handleEndProcessActionChange = {(e) => this.handleEndProcessActionChange(e)} endProcessActionsList={endProcessActionsList}/>}
          </div>
        </Grid>

        <Grid item xs={12}>
          <Box sx={styles.boxClass}>
          <div style={{ textAlign: "right" }}>
            <Button onClick={this.handleSave} sx={styles.saveButton} variant="contained" disabled = {isDisabled} >
              Kaydet ve Başlat
            </Button>
            </div>
          </Box>
        </Grid>

      </Grid>
    </Box>
    </ScreenContainer>
    </BasicPageComponent>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

NewProcess.propTypes = {
  actions: PropTypes.shape({
    setNotification: PropTypes.func
  })
};

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
)(NewProcess);